import { createPatchEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityApplicationBase } from '@types';

export type PatchDataSecurityApplicationByIdRequest = Partial<Omit<DataSecurityApplicationBase, 'monitors'>> & {
	applicationId: number;
	rawSalesforceId?: string | null;
};

export const patchDataSecurityApplicationById = createPatchEndpoint<PatchDataSecurityApplicationByIdRequest>(
	({ applicationId }) => `/api/v3/data-security/applications/${applicationId}`,
	{
		requestTransform: ({ applicationId, ...rest }) => rest
	}
);
